import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { useDispatch } from "react-redux";

const TabDates = ({ setFrom,perPage, from, to, setTo, onChange }) => {
  const [activeTab, setActiveTab] = useState("Today");

  const dispatch = useDispatch();

  useEffect(() => {
    const today = new Date();
    // setFrom();
    switch (activeTab) {
      case "Today":
        setFrom(format(today, "yyyy-MM-dd"));
        setTo(format(today, "yyyy-MM-dd"));
        break;
      case "Last 7 Days":
        const last7Days = new Date(today);
        last7Days.setDate(today.getDate() - 7);
        setFrom(format(last7Days, "yyyy-MM-dd"));
        setTo(format(today, "yyyy-MM-dd"));
        break;
      case "Last 30 Days":
        const last30Days = new Date(today);
        last30Days.setDate(today.getDate() - 30);
        setFrom(format(last30Days, "yyyy-MM-dd"));
        setTo(format(today, "yyyy-MM-dd"));
        break;
      default:
        setFrom("");
        setTo("");
    }
  }, [activeTab]);

  useEffect(() => {
    if (from && to) {
      onChange();
      return;
    }
  }, [from,to,perPage]);

  return (
    <div className="mt-3">
      <div className="flex  flex-col gap-4  lg:flex-row justify-between items-center border-b">
        <div>
          {["Today", "Last 7 Days", "Last 30 Days"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`py-2 px-6 text-sm font-medium transition-colors duration-300 ${
                activeTab === tab
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-500 hover:text-blue-500"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="flex gap-4  items-center">
          <input
            type="date"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            className="input"
          />
          <p>TO</p>
          <input
            type="date"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            className="input"
          />
        </div>
      </div>
    </div>
  );
};

export default TabDates;
